import deskGroupsService from '@/api/deskgroups'
import {DESK_GROUPS} from '../types'

export default {
  namespaced: true,
  state: {
    deskGroups: [],
    groupId: null,
    groupName: '',
    groupDesks: [],
    availableDesks: [],
    deskAttributes: [],
    isDownloadingFile: false
  },
  getters: {
    groupName(state) {
      return state.groupName
    },
    groupDesk(state) {
      return state.groupDesks
    },
    deskAttributes(state) {
      return state.deskAttributes
    },
    isDownloadingFile: (state) => {
      return state.isDownloadingFile
    },
  },
  mutations: {
    [DESK_GROUPS.SET_GROUPS](state, deskGroups) {
      state.deskGroups = deskGroups
    },
    [DESK_GROUPS.SET_ID] (state, id) {
      state.groupId = id
    },
    [DESK_GROUPS.SET_GROUP_NAME] (state, groupName) {
      state.groupName = groupName
    },
    [DESK_GROUPS.SET_GROUP_DESKS] (state, desks) {
      state.groupDesks = desks
    },
    [DESK_GROUPS.SET_AVAILABLE_DESKS] (state, availableDesks) {
      state.availableDesks = availableDesks
    },
    [DESK_GROUPS.SET_DESK_ATTRIBUTES] (state, deskAttributes) {
      state.deskAttributes = deskAttributes
    },
    [DESK_GROUPS.SET_IS_DOWNLOADING_FILE] (state, value) {
      state.isDownloadingFile = value
    }
  },
  actions: {
    async getDeskGroups ({dispatch, commit}) {
      let response = await deskGroupsService.getDeskGroups()
      commit(DESK_GROUPS.SET_GROUPS, response.data)
      dispatch('resetGroup')
    },
    setId({commit}, id){
      commit(DESK_GROUPS.SET_ID, id)
    },
    setGroupName({commit}, groupName){
      commit(DESK_GROUPS.SET_GROUP_NAME, groupName)
    },
    setDesk({commit}, desk){
      commit(DESK_GROUPS.SET_GROUP_DESKS, desk)
    },
    setIsDownloadingFile ({commit}, value) {
      commit(DESK_GROUPS.SET_IS_DOWNLOADING_FILE, value)
    },
    resetGroup({dispatch}){
      dispatch('setId', null)
      dispatch('setGroupName', '')
      dispatch('setDesk', [])
    }
  }
}